<template>
  <section class="xicon-component">
    <svg class="icon" aria-hidden="true">
      <use v-bind:xlink:href="iconType"></use>
    </svg>
  </section>
</template>
<script>
export default {
  /******************************************
  ** 图标组件库
  * @description 图标组件库，应用文档见：https://codesign.qq.com/help/tutorials/icon-library#%E4%B9%9D%E3%80%81%E4%BD%BF%E7%94%A8-cdn-%E8%B0%83%E7%94%A8%E5%9B%BE%E6%A0%87%E5%BA%93
  * @author stone
  *****************************************
  src          string            图标id引用
  *****************************************/
  name: 'xicon',
  components: {},
  props: {
    src: String
  },
  data () {
    return {}
  },
  computed: {
    iconType () {
      return `#${this.src}`
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
